import React, { useRef } from "react";
import api from "./../../../const/axios";
import { Camera } from "lucide-react";

interface UploaderProps {
  imageUpload: (url: string) => void;
}

const Uploader: React.FC<UploaderProps> = ({ imageUpload }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFile = async (file: File) => {
    const isJpgOrPng =
      (file.type === "image/jpeg" || file.type === "image/png") &&
      !file.name.endsWith(".svg");
    if (!isJpgOrPng) {
      alert("Yalnızca png və jpg formatında şəkillər yükləyə bilərsiniz.");
      return;
    }
    if (file.size / 1024 / 1024 >= 2) {
      alert("Faylın ölçüsü 2 meqabaytdan kiçik olmalıdır.");
      return;
    }
    const formData = new FormData();
    const filename = Math.floor(Math.random() * 999999) + 1 + Date.now() + file.name;
    formData.append("file", file, filename);
    const res = await api.post("users/photo", formData, {
      headers: { "content-type": "multipart/form-data" },
    });
    // API now returns { id, name, folder }. We pass the name for compatibility.
    imageUpload(res.data.name || res.data);
  };

  return (
    <div
      onClick={() => inputRef.current?.click()}
      className="w-36 h-36 rounded-full border-2 border-dashed border-blue-300 bg-blue-50 dark:bg-blue-950 flex flex-col items-center justify-center cursor-pointer hover:bg-blue-100 transition-colors"
    >
      <Camera className="w-8 h-8 text-blue-400 mb-1 dark:text-indigo-300" />
      <span className="text-xs text-blue-500 font-medium dark:text-indigo-300">Yüklə</span>
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png"
        className="hidden"
        onChange={e => {
          const f = e.target.files?.[0];
          if (f) handleFile(f);
        }}
      />
    </div>
  );
};

export default Uploader;
